var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#006EFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2137 26.3283L30.8356 22.2331H26.9452V19.5768C26.9452 18.4562 27.4877 17.3632 29.2301 17.3632H31V13.8768C31 13.8768 29.3945 13.6001 27.8603 13.6001C24.6548 13.6001 22.5616 15.5619 22.5616 19.1119V22.2331H19V26.3283H22.5616V36.2285C23.2767 36.342 24.0082 36.4001 24.7534 36.4001C25.4986 36.4001 26.2301 36.342 26.9452 36.2285V26.3283H30.2137Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.4ce76a302b167296358e7481d590bda3.svg";
export { ForwardRef as ReactComponent };